import { render, staticRenderFns } from "./BaseAddressDisplay.vue?vue&type=template&id=10cb16b7&scoped=true&"
import script from "./BaseAddressDisplay.vue?vue&type=script&lang=js&"
export * from "./BaseAddressDisplay.vue?vue&type=script&lang=js&"
import style0 from "./BaseAddressDisplay.vue?vue&type=style&index=0&id=10cb16b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cb16b7",
  null
  
)

export default component.exports